import { CUSTOMER_MANAGEMENT } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getCustomerManagement = (payload) => {
  return apiInstance.post(CUSTOMER_MANAGEMENT, payload);
};
